import React, { forwardRef } from "react"
import Typography from "@mui/material/Typography"
import { MDTypographyProps } from "./types"

const MDTypography = forwardRef<HTMLDivElement, MDTypographyProps>(({ children, ...rest }, ref) => (
  <Typography ref={ref} {...rest}>
    {children}
  </Typography>
))

MDTypography.displayName = "MDTypography"

export default MDTypography
